<script setup lang="ts">
import type { SectionSuggestion } from "./types";
import { FrameIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

defineProps<{
  item: SectionSuggestion;
}>();
</script>

<template>
  <SuggestionListItem
    :icon="FrameIcon"
  >
    {{ item.name }}
  </SuggestionListItem>
</template>
